/**
 * 积分列表
 * */
import React from 'react'
import Lang from '@components/Lang/Lang'
import { Spin,} from "antd";
import {getIntlYYMMDD,isEmpty,isEmptyObject,trim,getFileSuffix,symbolMoneyUtil, } from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
// import {Link} from "react-router-dom";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import UserScore from "../components/UserScore";
import qs from 'query-string';
import { toFixedWithCommas} from "@utils/number-util";
import HttpServerAction from '@/api/httpServer.action';
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import dayjs from 'dayjs';
import "./index.less";
export default class ScoreList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            scoreData: {},
            searchFormOptions:[
                {
                    name:'type',
                    cnPlaceholder:'请输入客户编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng ',
                    hiddenLabel:true,
                    type:"Radio",
                    // radioClass:"is_ka_buyer",options
                    options:[{
                        value: "",
                        title: Lang({id:'QuanBu',default:'全部'}),
                    },{
                        value: "1",
                        title: Lang({id:'ShouRu',default:'收入'}),
                    },{
                        value: "-1",
                        title: Lang({id:'ZhiChu',default:'支出'}),
                    },]
                },
                {
                    name:'time',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['startTime','endTime'],
                    type:'DateRangePicker',
                    width:300,
                    hiddenLabel:true,
                    canSearch:false,
                },
            ],
            // 列
            columns: [
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    width: 200,
                    fixed: "left",
                    dataIndex: 'createTime',
                    render: (createTime, record, index) => (<div>
                        {record.createTime? dayjs(record.createTime).format("YYYY-MM-DD HH:mm:ss"): "-"}
                    </div>),
                },
                {
                    cnTitle: '积分变动',
                    cnTitleId: 'JiFenBianDong',
                    dataIndex: 'point',
                    render: (point, record, index) => (<div>
                        {/*// type 1:收入 -1:支出，不传查询全部*/}
                        {record.type==1?<div className={"fw_700 black89"}>+ {point}</div>:<div className={"fw_700 black45"}>- {point}</div>}
                    </div>),
                },
                {
                    cnTitle: '积分余额',
                    cnTitleId: 'JiFenYuE',
                    dataIndex: 'afterPoint',
                    render: (afterPoint, record, index) => (
                        <div className={"fw_700 black89"}>{afterPoint|| "0"}</div>
                    ),
                },
                {
                    cnTitle: '备注',
                    cnTitleId: 'BeiZhu',
                    dataIndex: 'remake',
                },
            ],
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    handleGetRes(res) {
        const {success, valid, model} = res;
        this.loading(false);
        if (success && valid&&model) {
            this.setState({
                scoreData:model,
                // showModal:true
            })
        }
    }
    fetchData(buyerId){
        if(!buyerId){
            return false;
        }
        // http://rap.essa.top:88/workspace/myWorkspace.do?projectId=257#8600
        HttpServerAction.postHttpAction('/mg/buyer/query-point-detail-info',{
            buyerId: buyerId,
        },).then((resp)=>this.handleGetRes(resp.data)).catch(err=>this.handleGetRes(err));
    }
    refreshTableData(){
        this.onRefTabChildOne.handleFetch(1,{},true)
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentWillMount(){
        const {id} = qs.parse(this.props.location.search)
        this.fetchData(id);
        this.setState({
            buyerId:id
        })
    }
    render() {
        const {buyerId,loading, scoreData, columns=[],searchFormOptions=[]} = this.state;
        return (<Spin spinning={loading}>
                    <PageCommon>
                <CommonBreadcrumb list={[
                    {name: Lang({id:'YiChengJiaoKeHu',default:"已成交客户"}),link:"/customer/completed"},
                    {name:Lang({id:'ZhangHaoXiangQing',default:"客户详情"}),link:"/customer/detail?id="+buyerId},
                    {name:Lang({id:'JiFenGuanLi',default:"积分管理"})}
                ]}></CommonBreadcrumb>
                
                {/* 积分概览 */}
                <div className="score-header mt_24 mb_30">
                    <div className="score-info flex-item">
                        <div className={"black89"}>{Lang({id:"NDeJiFen",default:"{0}的积分",params:[`${scoreData.buyerCode}`]})}</div>
                        <div className="score-value ml_6">{scoreData.point||0}</div>
                        {scoreData.deductAmount>0?<div className="black45 ml_12">{Lang({id:"KeDiKou",default:"可抵扣"})}：
                            {symbolMoneyUtil(scoreData.deductAmount,scoreData.currencySymbol)}
                        </div>:null}
                        {scoreData.canAddPoint>0?<div className="black66 ml_12">{Lang({id:"YuJiJiJiangDaoZhang",default:"预计即将到账 {0}",params:[`+ ${scoreData.canAddPoint||0}`]})}</div>:null}
                    </div>
                    <UserScore row={{
                        id:buyerId
                    }} successCallBack={()=>this.refreshTableData()}/>
                </div>
                {/*表格*/}
                {buyerId?<AutoFetchTable columns={columns}
                                searchFormOptions={searchFormOptions}
                                onRef={this.onRefTabOne}
                                precondition={{
                                    buyerId:buyerId,
                                }}
                                rowKey={"remittanceId"}
                                scroll={{ x: 1200 }}
                                flagShowReset = {false}
                                // http://rap.essa.top:88/workspace/myWorkspace.do?projectId=257#8599
                                fetchApi={'/mg/buyer/query-point-list'}
                                pageSize={50}>
                </AutoFetchTable>:null}

            </PageCommon>
      </Spin>)
    }
}

